import { useCallback, useEffect, useRef, useState } from "react";

export default function useTimeout(callback, delay, callDirectly) {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef();
  const [hasStarted, setStarted] = useState(callDirectly);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const set = useCallback(() => {
    timeoutRef.current = setTimeout(() => callbackRef.current(), delay);
  }, [delay]);

  const clear = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    if (callDirectly) {
      set();
      return clear;
    }
  }, [delay, set, clear]);

  const reset = useCallback(() => {
    clear();
    set();
  }, [clear, set]);

  const start = useCallback(() => {
    set();
    return clear;
  });

  return { reset, clear, start };
}
